module.exports = __webpack_public_path__ + "assets/benefits-email-b98759.svg";